import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import PlusIcon from "../icons/PlusIcon.vue";
import { changeCase } from '../../helpers';
import { ElementE } from '../../enums';

export default /*#__PURE__*/_defineComponent({
  __name: 'AddWidgetBtn',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "btn-primary is-btn-size-default flex items-center gap-2",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click')))
  }, [
    _createVNode(PlusIcon),
    _createTextVNode(" " + _toDisplayString(_unref(changeCase)('add widget', _unref(ElementE).BUTTON)), 1)
  ]))
}
}

})